import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {storeToUrgencyMapping} from './helper';

/**
 * Decorator method to extract `urgency` from context and inject that prop into `ChildComponent`.
 * @param ChildComponent [ReactElement] The Child Component that has the injected with the `urgency` property.
 *
 */
const urgency = (ChildComponent) => {
  return class UrgencyComponent extends Component {
    static contextTypes = {
      globalRegistry: PropTypes.object,
    };
    render() {
      const urgencyConfig = storeToUrgencyMapping(this.context.globalRegistry.getStoreId());

      return <ChildComponent {...this.props} urgencyConfig={{...urgencyConfig}} />;
    }
  };
};

export default urgency;
export * from './helper';
